<template>
  <div class="submission-form">

    <CustomModal 
      :open="success_modal"
      :type="'success'"
      :size="'md'"
      @close-modal="vRefresh()">
      <template slot="modal_content">
        <div>
          <p>{{$_('submission_success')}}</p>
        </div>
      </template>
    </CustomModal>

    <CustomModal 
      :open="error_modal"
      :type="'error'"
      :size="'md'"
      @close-modal="error_modal = false">
      <template slot="modal_content">
        <div>
          <p>{{$_('submission_error')}}</p>
        </div>
      </template>
    </CustomModal>

    <form @submit.prevent="vSubmitForm">
      <div class="grid-row">
        <div class="column">
          <div class="radio-field">
            <div class="form-field">
              <input type="radio" class="radio" v-model="form_data.tar" :id="'submission_'+line+'_A'" v-bind:value="'A'"/>
              <label :for="'submission_'+line+'_A'">{{$_('accept_this_sample')}}</label>
            </div>
            <div class="form-field">
              <input type="radio" class="radio" v-model="form_data.tar" :id="'submission_'+line+'_R'" v-bind:value="'R'"/>
              <label :for="'submission_'+line+'_R'">{{$_('refuse_this_sample')}}</label>
            </div>
          </div>
        </div>
      </div>
        <div class="grid-row form-accept" v-if="form_data.tar === 'A'">
          <div class="column">
            <div class="form-field">
              <label>{{$_('time_requested')}}</label>
              <DatePicker
                :ref="'date'"
                @datepicker:select="vSelectTime($event)"
                :disableWeekEnd="true"
                :fromNextDay="true"
              />
            </div>
          </div>
          <div class="column">
            <div class="form-field">
              <label>{{$_('comment')}}</label>
              <input v-model="form_data.tcom" type="text" maxlength="75" />
            </div>
          </div>
          <div class="column">
            <div class="form-field" v-for="(sample, index) in samples" :key="index">
              <input type="radio" :id="'sample_'+form_data.tnsoum+'_'+index" class="radio" v-model="form_data.tcech" v-bind:value="sample"  />
              <label :for="'sample_'+form_data.tnsoum+'_'+index">{{sample}}</label>
            </div>
          </div>
        </div>

        <div class="grid-row form-refuse" v-else>
          <div class="column">
            <div class="form-field">
              <label>{{$_('reason')}}</label>
              <Select  
                :placeholder="$_('reason')" 
                :itemoption="['TCMOTIF', 'TLIB30']"
                @select-change="vSelectReasons($event)"
                :data="reasons"
              />   
            </div>
          </div>
          <div class="column">
            <div class="form-field">
              <label>{{$_('comment')}}</label>
              <input  v-model="form_data.tcom" type="text" maxlength="75" />
            </div>
          </div>
        </div>
        <div class="grid-row">
          <div class="column">
            <button class="btn">{{$_('validate').toUpperCase()}}</button>
          </div>
        </div>
    </form>
  </div>
</template>

<script>


import Select from '@/common/components/widget/Select'
import DatePicker from '@/common/components/widget/DatePicker'
import CustomModal from "@/common/components/widget/Modal/CustomModal";

import submissionService from '@/modules/soumission/services/submissionService';

export default {
  name: 'SubmissionForm',
  props: {
    tnb_ech: {
      type: Number,
      default: 0
    },
    line: {
      type: Number,
      default: 0
    }
  },
  components: {
    Select,
    DatePicker,
    CustomModal
  },
  data() {
    return {
      samples: Array(),
      reasons: Array(),
      success_modal: false,
      error_modal: false,
      form_data: {
        tnsoum: '',
        tar: 'R',
        tcech: '',
        tdelai_client: '',
        tcmotif: '',
        tcom: '',
      }
    }
  },
  created() {
    if(this.$props.tnb_ech > 0) {
      this.sAlphabetLetterFromNumber(this.$props.tnb_ech);
    }
    this.form_data.tnsoum = this.$props.line;

    submissionService.getStatus()
    .then(res => {
      res.data.DS_O.OUT.map(obj => {
        this.reasons.push(obj)
      })
    }).catch(err => {
      console.error(err);
    });    
  },
  computed: {
    getTar() {
      return this.form_data.tar;
    }
  },
  watch: {
    getTar() {
      Object.keys(this.form_data).map(key => {
        if(key !== 'tar' && key !== 'tnsoum') {
          this.form_data[key] = '';
        }
      });

      // if(this.samples.length === 1) {
        this.form_data.tcech =this.samples[0]
      // }
    }
  },
  methods: {
    sAlphabetLetterFromNumber(number) {

      let iteration = 1;
    
      for (let i = 'A'.charCodeAt(0); i <= 'Z'.charCodeAt(0); ++i) {
        if(iteration <= number) {
          this.samples.push(String.fromCharCode(i));
        }
        iteration++;
      }
    },
    vSelectReasons(event) {
      this.form_data.tcmotif = event.item;
    },
    vSelectTime(event) {
      var DateTmp = event.split('/');
      DateTmp.reverse();
      this.form_data.tdelai_client = DateTmp.join('-');
    },
    vRefresh() {

      this.$store.dispatch('soumission/SELECT', {key: 'reset_submission_list', value: true});

      setTimeout(() => {
        this.$store.dispatch('soumission/SELECT', {key: 'launch_research', value: true});
      }, 100);

      this.success_modal = false;
    },
    vSubmitForm() {

      let oData = {};

      oData.TNSOUM = this.form_data.tnsoum;
      oData.TAR = this.form_data.tar;

      if(this.form_data.tar === 'A') {

        if(this.$refs.date.$data !== undefined && this.$refs.date.$data.dateFormate === "") {
          this.$refs.date.$data.activate_required = true;
          return;
        } else {
          this.$refs.date.$data.activate_required = false;
        }

        oData.TCECH = this.form_data.tcech;
        oData.TDELAI_CLIENT = this.form_data.tdelai_client;

      } else if (this.form_data.tar === 'R') {

        oData.TCMOTIF = this.form_data.tcmotif;
      }

      oData.TCOM = this.form_data.tcom;

      submissionService.sendSubmission(oData)
      .then(res => {
        if(res.data !== undefined) {
          if(res.data.POK === 1) {
            this.success_modal = true;
          } else {
            this.error_modal = true;
          }
        }
      })
      .catch(err => {
        console.error(err);
      });
    }
  }
}
</script>

<style scoped>
.radio-field {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 420px;
}
/deep/
.select-box {
  margin:0px;
}
.form-accept, .form-refuse {
  max-width: 600px;
  display: flex;
  align-items: center;
}
/* .column.row {
  flex-direction: row;
  flex-basis: 20%
} */
</style>